const LocalStorageKeys = {
    LOGIN_TOKEN: 'Token',
    REFRESH_TOKEN: 'Refresh-Token'
}

export default LocalStorageKeys